<template>
  <div
    class="bg-surface-default-mid grid grid-cols-1 grid-rows-[min-content] pb-72"
  >
    <Navigation class="z-[9]" />

    <TheMainContent>
      <NuxtPage />
    </TheMainContent>
  </div>
</template>

<script lang="ts" setup>
import TheMainContent from '~/components/TheMainContent/TheMainContent.vue'

import Navigation from './components/Navigation/Navigation.vue'
</script>
